@if (!showAddresses) {
  <div class="form-group">
    @if (showLabel && (question?.question_copy || question?.email_version || labelText)) {
      <label [innerHtml]="question?.question_copy || question?.email_version || labelText" class="form-group__label"></label>
    }
    <form [formGroup]="locationForm" autocomplete="off">
      <div class="address-fields">
        <div class="form-group form-group--sm">
          <input appAutocomplete
            formControlName="apartmentNo"
            type="text"
            id="address_unit-1"
            placeholder="Apt / Unit No. (optional)"
            autocomplete="new-value"
            maxlength="10"
            [attr.data-id]="question?.data_test_id"
            (blur)="checkText($event)"
            class="form-control"/>
          </div>
          <div class="form-group form-group--sm">
            <input appAutocomplete
              formControlName="complex"
              type="text"
              placeholder="Complex / Estate Name (optional)"
              autocomplete="new-value"
              maxlength="120"
              [attr.data-id]="question?.data_test_id"
              (blur)="checkText($event)"
              class="form-control"/>
            </div>
            <div class="form-group form-group--lg">
              <div class="form-control__wrap has-clear ">
                <input type="text"
                  formControlName="streetAddress"
                  placeholder="Street Address"
                  autocomplete="new-value"
                  maxlength="50"
                  [attr.data-id]="question?.data_test_id"
                  (blur)="checkText($event)"
                  #addressText
                  class="form-control required"/>
                  <a href="#" id="clear-address-1" class="form-control__clear">
                    <svg class="icon">
                      <use xlink:href="#close-circle-small"></use>
                    </svg>
                  </a>
                </div>
                <!--
                <div class="text-right mt-1">
                  <img src="assets/img/google-poweredby.svg" width="120" />
                </div> -->
              </div>
              <div class="form-group form-group--sm ">
                <input appAutocomplete
                  formControlName="suburb"
                  type="text"
                  id="address_suburb-1"
                  placeholder="Suburb"
                  maxlength="50"
                  [attr.data-id]="question?.data_test_id"
                  autocomplete="new-value"
                  (blur)="checkText($event)"
                  class="form-control required"/>
                </div>
                <div class="form-group form-group--sm required ui-front">
                  <!--<select formControlName="province" (change)="changeProvince($event)" id="address_province-1" class="ui-selectmenu">
                  <option *ngFor="let item of provinces" [value]="item.id">{{item.value}}</option>
                </select>-->
                <app-question-dropdown
                  [options]="provinces"
                  [labelText]="'province'"
                  [selectedValue]="province"
                  (questionAnswer)="changeProvince($event)">
                </app-question-dropdown>
              </div>
              <div class="form-group form-group--sm ">
                <input appAutocomplete
                  formControlName="city"
                  type="text"
                  id="address_city-1"
                  placeholder="City"
                  maxlength="50"
                  [attr.data-id]="question?.data_test_id"
                  autocomplete="new-value"
                  (blur)="checkText($event)"
                  class="form-control required"/>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group form-group--sm">
                      <input appAutocomplete
                        formControlName="postalCode"
                        type="text"
                        id="address_postalcode-1"
                        placeholder="Postal Code"
                        autocomplete="new-value"
                        maxlength="10"
                        [attr.data-id]="question?.data_test_id"
                        (blur)="checkText($event)"
                        class="form-control required"/>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          }


          @if (showAddresses) {
            <div class="form-group">
              @for (add of addresses; track add) {
                <label class="custom-input custom-input--radio custom-input--pill">
                  <input type="radio"
                    (click)="setAddress(add)"
                    [attr.data-id]="question?.data_test_id"
                    [attr.data-answer]="add?.address"/>
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">{{add?.address}}</span>
                  </label>
                }
                <label class="custom-input custom-input--radio custom-input--pill">
                  <input type="radio"
                    [attr.data-id]="question?.data_test_id"
                    (click)="setAddress('new')"/>
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Not in the list</span>
                  </label>
                </div>
              }
